var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ff4f4f;}.cls-3{fill:#00305f;}.cls-4{fill:#e33b3b;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1594.2,497.2c-47.6,43.4-109.5,87.4-175.5,111.7a607.9,607.9,0,0,0-787.4,0c-66-24.3-127.9-68.3-175.5-111.7-63-57.4-68.5,165.6,45.7,265.6a605.3,605.3,0,0,0-84.6,309.5c0,335.8,272.3,608.1,608.1,608.1s608.1-272.3,608.1-608.1a605.3,605.3,0,0,0-84.6-309.5C1662.7,662.8,1657.2,439.8,1594.2,497.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 793.2,
    cy: 1008.9,
    rx: 94.9,
    ry: 60.2,
    transform: "translate(-249.1 1757.7) rotate(-87.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 826.5,
    cy: 1010.4,
    r: 16.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M881.2,1000.3a30.1,30.1,0,0,1-10.9-2.1L674.9,921.9a30,30,0,1,1,21.8-55.8l195.4,76.3a30,30,0,0,1-10.9,57.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1256.8,
    cy: 1008.9,
    rx: 60.2,
    ry: 94.9,
    transform: "translate(-42.5 55.4) rotate(-2.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1223.5,
    cy: 1010.4,
    r: 16.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1168.8,1000.3a30,30,0,0,1-10.9-57.9l195.4-76.3a30,30,0,1,1,21.8,55.8l-195.4,76.3A30.1,30.1,0,0,1,1168.8,1000.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,1516.7c-275.9,0-511.8-171.2-607.3-413.1,16.3,321.3,282,576.8,607.3,576.8s591-255.5,607.3-576.8C1536.8,1345.5,1300.9,1516.7,1025,1516.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M501.5,762.8c-7.6,12.8-14.8,26-21.4,39.4,35.2,9.8,76.2,14.8,76.2,14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1548.5,762.8c7.6,12.8,14.8,26,21.4,39.4-35.2,9.8-76.2,14.8-76.2,14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1136.7,1335a30,30,0,0,1-12-2.5c-67.1-29.4-132.3-29.4-199.4,0a30,30,0,0,1-24.1-55c82.1-36,165.5-36,247.6,0a30,30,0,0,1-12.1,57.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnger);
export default __webpack_public_path__ + "static/media/anger.ab2a176505dc0b4f1d83734a195a55ce.svg";
export { ForwardRef as ReactComponent };